import http from './helpers/httpInterceptor'

const state = () => ({
    configTableAll : [],
    updateTabaleConfig: [],
});

const mutations = {
    CONFIG_TABLE_ALL (states, data) {
        states.configTableAll = data
    },
    UPDATE_TABLE_CONFIG (states, data) {
        states.updateTabaleConfig = data
    }
};

const actions = {
    getConfigTableAll ({ commit }) {
        return http
            .get("/payroll/config-table/all")
            .then((res) => {
                commit("CONFIG_TABLE_ALL", res.data);
                return res.data;
            })
            .catch((error) => {
                throw (error)
            });
    },
    updateConfigTableAll({ commit}, payload) {
        return http 
        .post('/payroll/config-table/update', payload)
        .then(res => {
          commit("UPDATE_TABLE_CONFIG", res.data)
          return res.data
        })
        .catch(err => {
          throw err
        })
      },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}